import { PRODUCT_PERKS } from "@/constants/products"
import { convertPointToPrice } from "@/store/utils/util.utils"
import { getUserAimlabsSubscriptions, getUserSubscriptions } from "./subscriptions.api"
import { SUBSCRIPTION_PRODUCT_CATEGORIES } from "./subscriptions.constants"

const state = () => ({
  membershipSubscriptions: null,
  activeCoachSubscriptions: null,
  expiredCoachSubscriptions: null,
})

const mutations = {
  SET_MEMBERSHIP_SUBSCRIPTIONS: (state, subscriptions) => (state.membershipSubscriptions = subscriptions),
  SET_ACTIVE_COACH_SUBSCRIPTIONS: (state, subscriptions) => (state.activeCoachSubscriptions = subscriptions),
  SET_EXPIRED_COACH_SUBSCRIPTIONS: (state, subscriptions) => (state.expiredCoachSubscriptions = subscriptions),
}

const actions = {
  async loadUserSubscriptions ({ state, commit, rootGetters }, { forceRefresh = false } = {}) {
    if (!rootGetters["User/getUser"]) {
      return
    }

    if (
      state.membershipSubscriptions !== null &&
      state.activeCoachSubscriptions !== null &&
      state.expiredCoachSubscriptions !== null &&
      !forceRefresh
    ) {
      return
    }

    try {
      const [proGuidesSubscriptions, aimlabsSubscriptions] = await Promise.all([
        getUserSubscriptions(),
        getUserAimlabsSubscriptions(),
      ])

      const proGuidesMembershipSubscriptions = proGuidesSubscriptions[SUBSCRIPTION_PRODUCT_CATEGORIES.PROGUIDES_MEMBERSHIP] ?? []
      const aimlabsMembershipSubscriptions = aimlabsSubscriptions[SUBSCRIPTION_PRODUCT_CATEGORIES.PROGUIDES_MEMBERSHIP] ?? []
      commit("SET_MEMBERSHIP_SUBSCRIPTIONS", proGuidesMembershipSubscriptions.concat(aimlabsMembershipSubscriptions))

      const activeCoachSubscriptions = proGuidesSubscriptions[SUBSCRIPTION_PRODUCT_CATEGORIES.COACH_SUBSCRIPTION]?.active ?? []
      commit("SET_ACTIVE_COACH_SUBSCRIPTIONS", activeCoachSubscriptions)

      const expiredCoachSubscriptions = proGuidesSubscriptions[SUBSCRIPTION_PRODUCT_CATEGORIES.COACH_SUBSCRIPTION]?.expired ?? []
      commit("SET_EXPIRED_COACH_SUBSCRIPTIONS", expiredCoachSubscriptions)
    } catch (error) {
      console.error("Failed to fetch User subscriptions.", error)
    }
  },
}

const getters = {
  membershipSubscriptions: state => state.membershipSubscriptions ?? [],
  activeCoachSubscriptions: state => state.activeCoachSubscriptions ?? [],
  expiredCoachSubscriptions: state => state.expiredCoachSubscriptions ?? [],
  userMembershipTrialState: state => {
    const mostRelevantSubscription = state.membershipSubscriptions?.[0] ?? null
    return mostRelevantSubscription?.product?.billing_details.trial ?? null
  },
  membershipPerks: state => {
    const membershipSubscriptions = state.membershipSubscriptions ?? []
    return membershipSubscriptions.reduce((perks, subscription) => {
      return perks.concat(subscription.product?.perks ?? [])
    }, [])
  },
  membershipIncludesPremiumContentAccess: (state, getters) => {
    return !!getters.membershipPerks.find(
      (perk) => perk.identifier === PRODUCT_PERKS.GAME_MEMBERSHIP && perk.games.length > 0
    )
  },
  // TODO: Decouple discovery access from premium content access
  membershipIncludesDiscoveryAccess: (state, getters) => {
    return getters.membershipIncludesPremiumContentAccess
  },
  creditIssuedInUsdPerMonth: (state, getters) => {
    const creditPerks = getters.membershipPerks.filter(
      (perk) => perk.identifier === PRODUCT_PERKS.CREDIT
    )
    return creditPerks.reduce((amount, perk) => {
      return amount + convertPointToPrice(perk?.amount ?? 0)
    }, 0)
  },
  coachingDiscountPercentage: (state, getters) => {
    const discountPerks = getters.membershipPerks.filter(
      (perk) => perk.identifier === PRODUCT_PERKS.COACHING_DISCOUNT
    )
    return discountPerks.reduce((percentage, perk) => {
      return Math.max(percentage, perk?.percentage ?? 0)
    }, 0)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/user/subscriptions/subscriptions.module.js